
import request from '@/utils/request'

// /reimbursement/{id}
// 查询单个
export function queryById(id) {
    return request({
        url: '/biz-counselor-affirm/' + id,
        method: 'get',
    })
}

// 添加
export function add(data) {
    return request({
        url: '/biz-counselor-affirm',
        method: 'post',
        data
    })
}

// 删除
export function del(params) {
    return request({
        url: '/biz-counselor-affirm/',
        method: 'delete',
        params
    })
}

